// src/pages/shop-settings-tabs/ShopInfoTab.jsx
import React from 'react';
import LogoUploadCard from '../../components/settings/LogoUploadCard';
import ThemeColorCard from '../../components/settings/ThemeColorCard';
import ShopNameCard from '../../components/settings/ShopNameCard';
import ShopTagCard from '../../components/settings/ShopTagCard';
import ContactInfoCard from '../../components/settings/ContactInfoCard';

const ShopInfoTab = ({ settings, updateField, logoPreview, handleLogoChange }) => (
  <div className="space-y-6">
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
      <div className="space-y-6">
        <LogoUploadCard logoPreview={logoPreview} onLogoChange={handleLogoChange} />
        <ThemeColorCard color={settings.primary_color} onChange={c => updateField('primary_color', c)} />
      </div>
      <div className="lg:col-span-2 space-y-6">
        <ShopNameCard settings={settings} onChange={updateField} enabledLanguages={settings.enabled_languages} />
        <ShopTagCard settings={settings} onChange={updateField} enabledLanguages={settings.enabled_languages} />
      </div>
    </div>
    {/* 联系方式这张卡片占满整行宽度——里面含客服系统app_key/app_secret这一大块，
        塞在窄栏里显得拥挤，独占一整行才能让内部的两栏布局真正舒展开 */}
    <ContactInfoCard settings={settings} onChange={updateField} />
  </div>
);

export default ShopInfoTab;